module.exports = __webpack_public_path__ + "static/media/bg-pattern-bottom-mobile.1cb1d174.svg";